import { addTelemetryEventGA4, GA4EventAction, GA4EventCategory, GA4EventType } from '../Telemetry/TelemetryGA4';

export function addTelemetryEventForApplicationCompletion() {
	addTelemetryEventGA4({
		event: GA4EventType.generate_lead,
		category: GA4EventCategory.leads,
		action: GA4EventAction.henkilohakemus,
	});
}

export function addTelemetryEventForCompanyApplicationCompletion() {
	addTelemetryEventGA4({
		event: GA4EventType.contact_form,
		category: GA4EventCategory.leads,
		action: GA4EventAction.yrityshakemus,
	});
}
